import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { AppInterface } from '../../../interfaces/app.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class AppDescriptionCriteria implements SearchCriteria {
  getMatchScore(_app: AppInterface, _query: string): number {
    const hasMatch = [_app.description?.text, ...(_app.translatedDescriptions ?? [])].some(
      (_text) => _text?.toLowerCase().includes(_query),
    );
    return hasMatch ? 1 : 0;
  }

  getRelevanceFieldWeightAndMatchScore(_app: AppInterface, _query: string): SearchPriorityConfig {  
    return {
      relevanceField: SEARCH_FIELD.DESCRIPTION,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.DESCRIPTION,
      matchScore: this.getMatchScore(_app, _query)
    }
  }
}
